import { useState } from "react";
import { Typography, Button, FormControlLabel, Checkbox } from "@mui/material";


const Register = ({ close, register }) => {
  const [checked, setChecked] = useState(false);



  return (
    <div
      style={{
        height: "100vh",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Typography variant="h5" align="center">
            The Not-So-Fine Print
          </Typography>
          <Typography>
            By registering for the Skill Swap event, you acknowledge and agree
            that The Next Fun Match (operated by Aisle 2 LLC) serves only as a
            matching facilitator between participants. We do not guarantee the
            quality, completion, or satisfaction of services exchanged. All
            interactions and transactions between matched individuals occur
            solely at their own discretion and risk. Aisle 2 LLC explicitly
            disclaims all liability arising from or related to any services,
            agreements, disputes, damages, or claims of any kind involving event
            participants. By participating, you agree to release, indemnify, and
            hold harmless Aisle 2 LLC and its affiliates, officers, employees,
            contractors, and agents from any liability, claims, damages, or
            expenses (including legal fees) arising directly or indirectly from
            your participation in the Skill Swap event or related interactions.
            Additionally, by registering, you agree to be connected via email
            with participants who match your provided services and needs. Only
            your email address and first name will be shared with matched
            individuals. You may cancel your participation at any time, which
            will cease future matching notifications but will not rescind any
            match emails previously sent. Participation constitutes acceptance
            of these terms.
          </Typography>
          <Typography></Typography>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox checked={checked} onClick={() => setChecked(!checked)} />
          }
          label="I agree to these terms"
        />
        <Button variant="contained" disabled={!checked} onClick={register}>
          Register
        </Button>
        <Button variant="outlined" onClick={close}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default Register;
